import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const VideoGallery = () => {
  

  return (
    <>
      <Breadcrumb 
            pageTitle="Video Gallery"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Video Gallery" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
      <section className="space-ptb">
         <div class="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="section-title mb-4">
                <h2 className="title">
                  <span className="text-primary">Video Gallery</span>
                  <div className="curved-line mx-auto mt-3"></div>
                </h2>
              </div>
            </div>
          </div>       
     
          <div className='smart-classroom'>
          <div className="image-gallery">
               <div className="image-item">
                  <iframe id="ContentPlaceHolder1_Repeater1_iframe1_0" width="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" src="https://www.youtube.com/embed/STeSbLdhwN8?si=CQiVQ2UVuSd6eYO-" title=""></iframe>
              </div>
              
              <div className="image-item">
                  <iframe id="ContentPlaceHolder1_Repeater1_iframe1_2" width="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" src="https://www.youtube.com/embed/jKwAWicGRX8" title=""></iframe>
              </div>
              <div className="image-item">
                  <iframe id="ContentPlaceHolder1_Repeater1_iframe1_0" width="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" src="https://www.youtube.com/embed/VnIbErTBfWg" title=""></iframe>
              </div>
              <div className="image-item">
                  <iframe id="ContentPlaceHolder1_Repeater1_iframe1_1" width="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" src="https://www.youtube.com/embed/8wDU-HU9F0w" title=""></iframe>
              </div>
              <div className="image-item">
                  <iframe id="ContentPlaceHolder1_Repeater1_iframe1_3" width="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" src="https://www.youtube.com/embed/_uDX88cidH4?si=legMQKf9hTYMtINz" title=""></iframe>
              </div>
              <div className="image-item">
                  <iframe id="ContentPlaceHolder1_Repeater1_iframe1_4" width="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" src="https://www.youtube.com/embed/4p8FirONBvI" title=""></iframe>
              </div>
              <div className="image-item">
                  <iframe id="ContentPlaceHolder1_Repeater1_iframe1_5" width="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" src="https://www.youtube.com/embed/fmcTw4fEWrA" title=""></iframe>
              </div>
              <div className="image-item">
                  <iframe id="ContentPlaceHolder1_Repeater1_iframe1_6" width="100%" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" src="https://www.youtube.com/embed/_jJKBLiFQ_4" title=""></iframe>
              </div>
             
           
          </div>
              
          </div> 
          </div>
      </section>

      <style jsx>{`       
        .smart-classroom {
          padding: 20px 20px;
          background: #f8f8f8;
          margin-bottom:40px;
          border-radius:5px;
        }

        .image-gallery {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
          margin-bottom: 30px;          
        }

        .image-item img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          transition: transform 0.3s ease;
        }

        .image-item img:hover {
          transform: scale(1.05);
        }


        .description-text {
          font-size: 1rem;
          line-height: 1.6;
          color: #4a5568;
          margin-bottom: 15px;
          text-align: justify;
        }

        .description-text:last-child {
          margin-bottom: 0;
        }

        @media (max-width: 768px) {          

          .image-gallery {
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 15px;
          }

          .image-item img {
            height: 150px;
          }

          .description-text {
            font-size: 0.95rem;
            text-align: left;
          }
        }

        @media (max-width: 480px) {    
          .image-gallery {
            grid-template-columns: 1fr;
          }

          .image-item img {
            height: 120px;
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .smart-classroom {
          animation: fadeIn 0.5s ease-out;
        }

        .image-item img:focus {
          outline: 2px solid #2c5282;
          outline-offset: 2px;
        }
      `}</style>
    </>
  );
};


export default VideoGallery

